<mat-dialog-content>
  <div class="inpt-section">
    <div class="custom-title" i18n>Test Panel Name</div>
    <app-input [formCntlName]="testPanelNameControl" [inputType]="'text'" [placeholder]="inptPlaceHolder"></app-input>
  </div>
  <div class="custom-title" i18n>File Upload</div>
  <p i18n>Select and upload the files of your choice</p>
  <div class="upload-conatiner" #dropzoneElement>
    <div class="custom-dropzone">
      <div class="icon-container">
        <img src="assets/icons/upload-cloud.svg" i18n-alt alt="upload-cloud-icon" />
      </div>

      <div class="description">
        <p class="title-text modal-sub-heading" i18n>Select a file or drag and drop it here</p>
        <p class="sub-title-text" i18n>Supports only .txt files.</p>
      </div>
      <app-buttons
        class="fileinput-button"
        [isDisabled]="false"
        [name]="selectFileBtnText"
        [buttonType]="btnMatStroked"
        [buttonStyle]="btnStyleStroked"
      ></app-buttons>
    </div>

    <div id="preview-template" style="display: none">
      <div class="dz-preview dz-file-preview">
        <div class="dz-details">
          <div class="dz-thumbnail">
            <img data-dz-thumbnail />
          </div>
        </div>
        <div class="dz-file-details-container">
          <div class="dz-info">
            <div class="dz-file-details">
              <div class="dz-filename-container">
                <span class="dz-filename" data-dz-name></span>
                <span class="dz-completed-status" style="display: none"></span>
              </div>
              <span class="dz-file-size" data-dz-size></span>
            </div>
          </div>
          <div class="dz-progress">
            <span class="dz-upload" data-dz-uploadprogress></span>
          </div>
          <div class="dz-error">
            <img data-dz-error />
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <app-buttons
    [isDisabled]="isDoneBtnDisabled"
    [name]="'Done'"
    [buttonType]="'mat-flat-button'"
    [buttonStyle]="isDoneBtnDisabled ? 'btn-filled-small-disabled' : 'btn-filled-small'"
    (buttonClickEvent)="onPrimaryAction()"
  >
  </app-buttons>
</mat-dialog-actions>
